import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FuzzySearchWidget from 'components/FuzzySearchWidget';
import cns from 'classnames';

import cn from './styles.local.less';

export default class WelcomeBanner extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    imageUrl: PropTypes.string,
  };

  getBackgroundImageStyle() {
    const { imageUrl } = this.props;

    return {
      background: `url(${imageUrl}) no-repeat center`,
      backgroundSize: 'cover',
    };
  }

  render() {
    const { title, subTitle } = this.props;

    return (
      <div className={cn.root}>
        <div className={cn.innerContainer}>
          <span
            style={this.getBackgroundImageStyle()}
            className={cns(cn.bgImageBlock, 'hidden-xs')}
          />
          <h1 className={cn.title}>{title}</h1>
          <span className={cns(cn.subTitle, 'hidden-xs')}>{subTitle}</span>

          <FuzzySearchWidget />
        </div>
      </div>
    );
  }
}
